import { AxiosRequestConfig } from 'axios';

import { HttpMethods } from 'constants/requestHeaders';
import { STORE_KEY_IN_QUERY } from 'constants/store';
import { appendQueryStringToUrl } from 'shared/helpers/utils/url';
import { RequestConfig } from '..';


export const storeParam = (requestConfig: AxiosRequestConfig) => {
  const { headers, method, url, data } = requestConfig;

  if (headers.STORE) {
    const storeId = RequestConfig.getStoreId();

    if (storeId) {
      const lowerCaseMethod = method?.toLocaleLowerCase();
      if (url && (lowerCaseMethod === HttpMethods.GET)) {
        const modifiedUrl = appendQueryStringToUrl(url, `${STORE_KEY_IN_QUERY}=${storeId}`);
        requestConfig.url = modifiedUrl;
      } else if (lowerCaseMethod === HttpMethods.POST) {
        if (data instanceof FormData) {
          data.append(STORE_KEY_IN_QUERY, storeId);
        } else {
          requestConfig.data = {
            ...data,
            [STORE_KEY_IN_QUERY]: storeId,
          };
        }
      }
    }
  }
  delete headers.STORE;

  return requestConfig;
};
